import type { ClinicalImpression } from "@medplum/fhirtypes";
import { CLINICAL_IMPRESSION_COLLECTION_NAME } from "../../fhir";
import { createSubscriptionHook } from "./create-subscription-hook";

export const useClinicalImpressionSubscription = createSubscriptionHook<ClinicalImpression>(
  "ClinicalImpression",
  CLINICAL_IMPRESSION_COLLECTION_NAME,
);
